import React, { useEffect, useState } from "react";
import { Box, Text, HStack, SimpleGrid } from "@chakra-ui/react";
import HerVestTable from "../components/Table/HervestTable";
import moment from "moment";
import { formatMoney } from "../services/utils/helpersFunc";
import { getAllInstantLoanOffer } from "../services/axios";
import FilterComponent from "../components/Inputs/FilterComponent";
import { convertArrayOfObjectsToWorksheet } from "../services/utils/helpersFunc";
import { useNavigate } from "react-router-dom";
import { MdOutlinePendingActions, MdLibraryAdd } from "react-icons/md";
import { motion } from "framer-motion";
import { GiPayMoney, GiReceiveMoney } from "react-icons/gi";
import { FcCancel } from "react-icons/fc";
import { IoCheckmarkDoneCircle } from "react-icons/io5";
import { GrInProgress } from "react-icons/gr";

const columns = [
  {
    name: "S/N",
    key: "id",
  },
  {
    name: "Date",
    key: "date",
  },
  {
    name: "Amount",
    key: "amount",
  },
  {
    name: "Loan Request",
    key: "request_id",
  },
  {
    name: "Email",
    key: "email",
  },
  {
    name: "Total Repayment",
    key: "total_repayment",
  },
  {
    name: "Amount Paid So Far",
    key: "current_balance",
  },
  {
    name: "Balance Left",
    key: "balance_left",
  },
  {
    name: "Opening Balance",
    key: "opening_balance",
  },
  {
    name: "Loan Status",
    key: "status",
  },
];

function InstantLoanReconcillation() {
  const navigate = useNavigate();
  const [allLoanOffers, setallLoanOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({});
  const [summary, setSummary] = useState({});
  const [filters, setFilters] = React.useState({
    page: 1,
    pageLimit: 50,
  });

  const getInstantLoanOffers = async () => {
    setLoading(true);
    const res = await getAllInstantLoanOffer(filters);
    setLoading(false);
    if (res) {
      const mappedData = res.data.data.map((data, index) => {
        return {
          ...data,
          email: data?.instantLoanRequest?.email,
          created_at: moment(data.created_at).format("DD/MM/YYYY"),
          current_balance: `₦ ${formatMoney(data.current_balance)}`,
          opening_balance: `₦ ${formatMoney(data.opening_balance)}`,
          total_repayment: `₦ ${formatMoney(data.total_repayment)}`,
          balance_left: `₦ ${formatMoney(
            data.total_repayment - data.current_balance
          )}`,
          date: moment(data.created_at).format("DD/MM/YYYY"),
        };
      });
      setallLoanOffers(mappedData);
      setMeta(res?.data?.meta);
      setSummary(res?.data?.meta?.summary);
    }
    return;
  };

  const handlePageClick = (page) => {
    setFilters({
      ...filters,
      page: page.selected + 1,
      pageLimit: 50,
    });
    getInstantLoanOffers();
  };

  useEffect(() => {
    getInstantLoanOffers();
    // eslint-disable-next-line
  }, [filters]);

  const downloadHandler = async () => {
    const res = await getAllInstantLoanOffer({
      ...filters,
      exportData: true,
    });
    if (res) {
      const structuredData = res?.data.map((data) => ({
        "Loan Request ID": data?.instantLoanRequest_request_id,
        "First Name": data?.instantLoanRequest_first_name,
        "Last Name": data?.instantLoanRequest_last_name,
        "Middle Name": data?.instantLoanRequest_maiden_name,
        Email: data?.instantLoanRequest_email,
        "Phone Number": data?.instantLoanRequest_phone,
        "Date of Birth": data?.instantLoanRequest_dob,
        Gender: data?.instantLoanRequest_gender,
        Bvn: data?.instantLoanRequest_bvn,
        "Marital Status": data?.instantLoanRequest_marital_status,
        Address: data?.instantLoanRequest_address,
        "Office Address": data?.instantLoanRequest_nok_office_address,
        "Next of kin": data?.instantLoanRequest_nok_name,
        "Next of Email": data?.instantLoanRequest_email,
        "Next of kin Phone": data?.instantLoanRequest_nok_phone,
        "Loan Amount": data?.instantLoanRequest_final_amount,
        "Total Interest": data?.instant_loans_total_interest,
        "Total Repayment": data?.instant_loans_total_repayment,
        "Opening Balance": data?.instant_loans_opening_balance,
        "Current Balance": data?.instant_loans_current_balance,
        "Closing Balance": data?.instant_loans_closing_balance,
        "Loan Status": data?.instant_loans_status,
        "Loan Offer Date": moment(data?.instantLoanRequest_created_at).format(
          "DD/MM/YYYY"
        ),
      }));
      return convertArrayOfObjectsToWorksheet(
        structuredData,
        `Instant Loans Offers Report-${moment().format("LLL")}`
      );
    }
  };

  const options = [
    {
      id: 1,
      name: "Total Number of Instant Loans",
      value: `${meta?.totalVolume || 0}`,
      icon: (
        <MdLibraryAdd size="30px" color="#5B2E4F" style={{ margin: "10px" }} />
      ),
    },
    {
      id: 2,
      name: "Active Loans",
      value: `${summary?.totalActiveLoanCount || 0}`,
      icon: (
        <MdOutlinePendingActions
          size="30px"
          color="#5B2E4F"
          style={{ margin: "10px" }}
        />
      ),
    },
    {
      id: 3,
      name: "Closed Loans",
      value: `${summary?.totalClosedLoanCount || 0}`,
      icon: (
        <IoCheckmarkDoneCircle
          size="30px"
          color="#5B2E4F"
          style={{ margin: "10px" }}
        />
      ),
    },
    {
      id: 4,
      name: "Declined Loans",
      value: `${summary?.totalDeclinedLoanCount || 0}`,
      icon: <FcCancel size="30px" color="#5B2E4F" style={{ margin: "10px" }} />,
    },
    {
      id: 5,
      name: "Pending Loans",
      value: `${summary?.totalPendingLoanCount || 0}`,
      icon: (
        <GrInProgress size="30px" color="#5B2E4F" style={{ margin: "10px" }} />
      ),
    },
    {
      id: 6,
      name: "Total Disbused Loans",
      value: `₦ ${formatMoney(summary?.totalLoanDisbursed || 0)}`,
      icon: (
        <GiPayMoney size="30px" color="#5B2E4F" style={{ margin: "10px" }} />
      ),
    },
    {
      id: 6,
      name: "Total Repayment Received",
      value: `₦ ${formatMoney(summary?.totalRepaymentReceived || 0)}`,
      icon: (
        <GiReceiveMoney
          size="30px"
          color="#5B2E4F"
          style={{ margin: "10px" }}
        />
      ),
    },
  ];

  return (
    <Box
      bg="#F8F9FC"
      p={["20px 10px", "20px 10px", "20px 10px 20px 30px"]}
      h="100vh"
      w="100%"
    >
      <Text
        color="#5B2E4F"
        fontSize="18px"
        fontWeight="500"
        fontFamily="satoshiBold"
      >
        Instant Loan Reconcillation
      </Text>

      <SimpleGrid
        spacing="20px"
        minChildWidth={["100px", "70px", "50px", "30%"]}
        justify="space-between"
        mt="30px"
      >
        {options.map((option) => (
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.9 }}
            key={option.id}
            style={{ cursor: "pointer" }}
          >
            <HStack
              display={"flex"}
              justify={"space-between"}
              key={option.id}
              bg="#F8F1F6"
              borderRadius="6px"
              p="20px"
            >
              <Box>
                <Text
                  fontSize={["13px", "15px"]}
                  color="#33343D"
                  fontWeight="500"
                  fontFamily="satoshiBold"
                >
                  {option.name}
                </Text>
                <Text
                  fontSize="21px"
                  fontFamily="satoshiBolder"
                  color="#5B2E4F"
                  lineHeight="28.35px"
                >
                  {option.value}
                </Text>
              </Box>
              <Box h="50px" w="50px" bg="#FFFFFF" borderRadius="4px">
                {option.icon}
              </Box>
            </HStack>
          </motion.div>
        ))}
      </SimpleGrid>

      <FilterComponent
        filters={filters}
        setFilters={setFilters}
        downloadHandler={downloadHandler}
        statusData={[
          { name: "All", value: "" },
          { name: "Active", value: "active" },
          { name: "Pending", value: "pending" },
          { name: "Closed", value: "closed" },
          { name: "Declined", value: "declined" },
        ]}
      />

      <HerVestTable
        onClickHandler={(item) => {
          navigate(`/instant-loan/${item.request_id}`);
        }}
        meta={meta}
        data={allLoanOffers}
        columns={columns}
        loading={loading}
        handlePageClick={(value) => handlePageClick(value)}
      />
    </Box>
  );
}

export default InstantLoanReconcillation;
